import { usePage } from '@inertiajs/react'
import { t } from '@/shared/lib/i18n'
import type { SharedProps } from '@/shared/types/SharedProps'

const TenantAdminBanner = () => {
  const { tenantAdminBanner } = usePage<SharedProps>().props

  if (!tenantAdminBanner) return null

  const csrfToken =
    document.head.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''

  return (
    <div className="bg-blue-50 border-b border-blue-200 px-4 py-2 text-sm text-blue-900">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 sm:px-6">
        <span>
          {t('tenantAdminBanner.label')} <strong>{tenantAdminBanner.tenantName}</strong>
        </span>
        <form method="post" action={tenantAdminBanner.exitPath}>
          <input type="hidden" name="_method" value="delete" />
          <input type="hidden" name="authenticity_token" value={csrfToken} />
          <button
            type="submit"
            className="shrink-0 rounded border border-blue-400 bg-blue-100 px-2.5 py-1 text-xs font-medium text-blue-900 hover:bg-blue-200"
          >
            {t('tenantAdminBanner.exitButton')}
          </button>
        </form>
      </div>
    </div>
  )
}

export default TenantAdminBanner
